import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from React 18


import ScriptSnout from './Pages/ScriptSnout/ScriptSnout';
import Sos2ScriptSnout from './Pages/Sos2/ScriptSnout';

// document.addEventListener('DOMContentLoaded', () => {
//   const widgetEl = document.getElementById('script-snout-widget');
//   if (widgetEl) {
//     const props = JSON.parse(widgetEl.dataset.props || '{}');
//     createRoot(widgetEl).render(<div>Hello from React</div>);
//     // createRoot(widgetEl).render(<ScriptSnout movie={props} />);
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  const widgetEl = document.getElementById('script-snout-widget');
  if (widgetEl) {
    const props = JSON.parse(widgetEl.dataset.props || '{}');
    // When DER data exists the controller sets props.sos2 — mount the NEW Layered Read
    // (same component the /pcr ?v=2 route renders); otherwise the legacy one.
    const Component = props && props.sos2 ? Sos2ScriptSnout : ScriptSnout;
    createRoot(widgetEl).render(<Component movie={props} />);
} else {
    console.log("script-snout-widget not found");
  }
});